
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */
import PostLayout from "@src/layouts/PostLayout";
import GoogleMap from "@src/components/GoogleMap";
import InstaImage from "@src/components/InstaImage";
import LinkWithThumbnail from "@src/components/LinkWithThumbnail";
import { murakamiMasanori } from "@src/constants/authors";
import { harajukuTakeoutHyakuMeitenTakeout100TopImage } from "@src/constants/images";
import { meta as kevelosPageMeta } from "./kevelos.mdx";
import { meta as minoringoPageMeta } from "./minoringo.mdx";
import { meta as mokubazaPageMeta } from "./mokubaza.mdx";
import { meta as theGreatBurgerPageMeta } from "./the_great_burger.mdx";
import { meta as naprePageMeta } from "./napre.mdx";
export const meta = {
  path: "/media/harajuku/takeout_hyaku_meiten",
  title: "【テイクアウト】原宿・表参道でテイクアウトができる百名店６選",
  description: "原宿・表参道エリアでテイクアウトができる「食べログ百名店」に選ばれている名店をジャンル別にまとめたものになります。テイクアウトが可能な時間、支払い方法、アクセスも併せてまとめています。コロナ、コロナ後もテイクアウトが増えると思われますが、ぜひテイクアウトの際はご活用ください！",
  topImg: harajukuTakeoutHyakuMeitenTakeout100TopImage,
  author: murakamiMasanori,
  tags: ["行列店", "原宿", "人気店", "まとめ記事", "食べログ高評価", "テイクアウト", "行列情報"]
};

const layoutProps = {
  meta
};
const MDXLayout = ({ children }) => (
  <PostLayout meta={meta}>{children}</PostLayout>
)
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <p>{`原宿・表参道エリアでテイクアウトができる「食べログ百名店」に選ばれている名店を６店舗選出しました。`}</p>
    <p>{`ジャンル別にまとめているので、気分に応じて選んでいただけます！また、テイクアウトが可能な時間、支払い方法、アクセスも併せてまとめているので、選ぶときの参考にしてください。`}</p>
    <p>{`コロナ、コロナ後もテイクアウトが増えると思われますが、ぜひテイクアウトの際はご活用ください！`}</p>
    <h2>{`【ピザ】原宿・表参道：ケベロス(KEVELOS)`}</h2>
    <h3>{`百名店`}</h3>
    <p>{`2018,2019 年と２年連続受賞`}</p>
    <h3>{`食べログ`}</h3>
    <p>{`3.70(2020 年 5 月時点)`}</p>
    <h3>{`ピザ職人が釜で作るピザがテイクアウトできる！`}</h3>
    <InstaImage postId="B9BCBRqjP4M" mdxType="InstaImage" />
    <p>{`本格的な釜焼きのピザが食べられるお店として原宿・表参道エリアで人気のお店がケベロス(KEVELOS)。
通常のメニューに載っているピザが全て同じ値段でテイクアウトできるそう！`}</p>
    <h3>{`1 番人気のマリナーラ(1,300 円)`}</h3>
    <InstaImage postId="B6VLlg8gcci" mdxType="InstaImage" />
    <p>{`なんとトマト、バジル、熟成ニンニクだけで作るマリナーラが 1 番人気！`}</p>
    <h3>{`ピザの王道マルゲリータ(1,500 円)`}</h3>
    <InstaImage postId="B2UA6RAlSg-" mdxType="InstaImage" />
    <p>{`定番のマルゲリータも見た目よりもボリューム感のある大きさで、ピザ職人が作ってくれる！`}</p>
    <hr></hr>
    <p><strong parentName="p">{`ケベロスについて詳しく知りたい方はこちら ↓`}</strong></p>
    <LinkWithThumbnail meta={kevelosPageMeta} mdxType="LinkWithThumbnail" />
    <h3>{`テイクアウト可能時間`}</h3>
    <p>{`ランチ：11:30~14:30
ディナー：17:30~20:30`}</p>
    <h3>{`支払い方法`}</h3>
    <p>{`電子マネー：×
クレカ：×
現金：○`}</p>
    <h3>{`アクセス`}</h3>
    <GoogleMap lat={35.666367} lng={139.7026683} mdxType="GoogleMap" />
    <hr></hr>
    <h2>{`【ピザ】原宿・表参道：ナプレ 南青山本店`}</h2>
    <h3>{`百名店`}</h3>
    <p>{`2017,2018,2019 年と３年連続受賞`}</p>
    <h3>{`食べログ`}</h3>
    <p>{`3.77(2020 年 5 月時点)`}</p>
    <h3>{`イタリア人を唸らせる本場のピザ`}</h3>
    <InstaImage postId="B-wCetoHxE6" mdxType="InstaImage" />
    <p>{`ナポリピザを日本に初めて持ち込んだお店として知られ、ピザ職人が厳選した本場の食材と窯を使って作るピザは絶品！
３年連続百名店に選出されている味も人気も確かな名店です！`}</p>
    <h3>{`テイクアウトメニューも豊富`}</h3>
    <p>{`通常メニューと同じ価格で、数十種類のピザが食べられます！`}</p>
    <InstaImage postId="B-YfWrhghIG" mdxType="InstaImage" />
    <p>{`(値段：1500~3000 円)`}</p>
    <hr></hr>
    <p><strong parentName="p">{`ナプレ について詳しく知りたい方はこちら ↓`}</strong></p>
    <LinkWithThumbnail meta={naprePageMeta} mdxType="LinkWithThumbnail" />
    <h3>{`テイクアウト可能時間`}</h3>
    <p>{`ランチ：11:30 ～ 15:00
ディナー：18:30 ～ 21:30`}</p>
    <h3>{`支払い方法`}</h3>
    <p>{`電子マネー：×
クレカ：○
現金：○`}</p>
    <h3>{`アクセス`}</h3>
    <GoogleMap lat={35.6637122} lng={139.7098139} mdxType="GoogleMap" />
    <hr></hr>
    <h2>{`【カレー】原宿・北参道：カリーアップ（CURRY UP）`}</h2>
    <h3>{`百名店`}</h3>
    <p>{`2019 年に受賞`}</p>
    <h3>{`食べログ`}</h3>
    <p>{`3.72(2020 年 5 月時点)`}</p>
    <h3>{`テイクアウトは全て 800 円！`}</h3>
    <InstaImage postId="B4hQFAThMLi" mdxType="InstaImage" />
    <p>{`テイクアウトでも高いお店もたくさんありますが、なんと`}<strong parentName="p">{`800 円`}</strong>{`でテイクアウトができます！`}</p>
    <h3>{`メニューは５種類から選べます！`}</h3>
    <h4>{`バターチキンカレー`}</h4>
    <h4>{`牛すじカレー`}</h4>
    <InstaImage postId="B91K0upgn7X" mdxType="InstaImage" />
    <h4>{`キーマカレー`}</h4>
    <InstaImage postId="B87yulmHabM" mdxType="InstaImage" />
    <h4>{`ビーフカレー`}</h4>
    <h4>{`やさいのカレー`}</h4>
    <InstaImage postId="B9u0U9FAAgJ" mdxType="InstaImage" />
    <h3>{`テイクアウト可能時間`}</h3>
    <p>{`11:30–21:00`}</p>
    <h3>{`支払い方法`}</h3>
    <p>{`電子マネー：×
クレカ：×
現金：○`}</p>
    <h3>{`アクセス`}</h3>
    <p>{`原宿駅から徒歩 10 分
北参道駅から徒歩 8 分`}</p>
    <GoogleMap lat={35.6640724} lng={139.6852903} mdxType="GoogleMap" />
    <hr></hr>
    <h2>{`【カレー】原宿・明治神宮前：みのりんご`}</h2>
    <h3>{`百名店`}</h3>
    <p>{`2019 年に受賞`}</p>
    <h3>{`食べログ`}</h3>
    <p><strong parentName="p">{`3.75`}</strong>{`(2020 年 5 月時点)`}</p>
    <h3>{`女性に大人気の行列店`}</h3>
    <InstaImage postId="B_msNzYAyA9" mdxType="InstaImage" />
    <p>{`休日だと 1 時間~2 時間程度待つことが当たり前の行列店。
素材にこだわったカレーを提供しており、`}<strong parentName="p">{`カレーなのにヘルシー`}</strong>{`ということからお客さんは女性がたくさんいることで有名です！`}</p>
    <hr></hr>
    <p><strong parentName="p">{`みのりんご について詳しく知りたい方はこちらへ ↓`}</strong></p>
    <LinkWithThumbnail meta={minoringoPageMeta} mdxType="LinkWithThumbnail" />
    <h3>{`限定１０食のお弁当がある！？(前日予約可)`}</h3>
    <h4>{`キーマカレーとスパイシー唐揚げと冷しゃぶサラダ弁当(850 円)`}</h4>
    <p>{`こちらが限定１０食のお弁当になります！`}</p>
    <InstaImage postId="B_yyRX1DItJ" mdxType="InstaImage" />
    <p>{`前日からお弁当の予約ができるみたいなので、「絶対食べたい！」という方はお電話をしてみてください！
電話番号：03-6447-2414`}</p>
    <h4>{`キーマカレー(800 円)`}</h4>
    <p>{`食材と作り方にこだわったキーマカレーを行列に並ばずにテイクアウトできるなんて！
`}<strong parentName="p">{`限定ではない`}</strong>{`のでいつでもテイクアウト！`}</p>
    <InstaImage postId="B_MOIFbjq73" mdxType="InstaImage" />
    <h3>{`テイクアウト可能時間`}</h3>
    <p>{`ランチ：11:30 ～ 15:00
ディナー： 18:30 ～ 21:30`}</p>
    <h3>{`支払い方法`}</h3>
    <p>{`電子マネー：×
クレカ：×
現金：○`}</p>
    <h3>{`アクセス`}</h3>
    <p>{`原宿駅から徒歩 3 分
明治神宮駅から徒歩 6 分`}</p>
    <GoogleMap lat={35.672523} lng={139.7013421} mdxType="GoogleMap" />
    <hr></hr>
    <h2>{`【カレー】原宿・北参道：mokubaza`}</h2>
    <h3>{`百名店`}</h3>
    <p>{`2019 年に受賞`}</p>
    <h3>{`食べログ：3.75(2020 年 5 月時点)`}</h3>
    <h3>{`芸術的なキーマカレー`}</h3>
    <InstaImage postId="B_MNG1eB9GH" mdxType="InstaImage" />
    <p>{`インスタでもたくさん見かける、スノードームのようなキーマカレーが大人気のお店！
芸能人もお忍びで訪れるほどの人気店になっています！`}</p>
    <hr></hr>
    <p><strong parentName="p">{`mokubaza について詳しく知りたい方はこちらへ ↓`}</strong></p>
    <LinkWithThumbnail meta={mokubazaPageMeta} mdxType="LinkWithThumbnail" />
    <h3>{`豊富なテイクアウトメニュー`}</h3>
    <p>{`これ以外のメニューもたくさんありますので、お店に行ってから決めてみるのもオススメです！
`}<strong parentName="p">{`チーズがテイクアウトだと乗せられないのが残念...`}</strong></p>
    <InstaImage postId="B-g4tUxD71i" mdxType="InstaImage" />
    <h3>{`テイクアウト可能時間`}</h3>
    <p>{`ランチ：11:30 ～ 14:30,
ディナー：19:30 ～ 23:00`}</p>
    <h3>{`支払い方法`}</h3>
    <p>{`電子マネー：×
クレカ：×
現金：○`}</p>
    <h3>{`アクセス`}</h3>
    <p>{`原宿駅から徒歩 9 分
北参道駅から徒歩 6 分`}</p>
    <GoogleMap lat={35.674572} lng={139.7072963} mdxType="GoogleMap" />
    <hr></hr>
    <h2>{`【ハンバーガー】原宿・明治神宮前：ザグレートバーガー`}</h2>
    <h3>{`百名店`}</h3>
    <p>{`2017,2018,2019 年と３年連続受賞`}</p>
    <h3>{`食べログ`}</h3>
    <p>{`3.77(2020 年 5 月時点)`}</p>
    <h3>{`原宿のハンバーガーといえばザグレートバーガー`}</h3>
    <InstaImage postId="B9NjvmtJkeb" mdxType="InstaImage" />
    <p>{`休日にはいつも行列が並んでいるお店。３年連続百名店に選ばれるなど、その味と人気は年々上がってきています。`}</p>
    <hr></hr>
    <p><strong parentName="p">{`ザグレートバーガーを詳しく知りたい方はこちらへ ↓`}</strong></p>
    <LinkWithThumbnail meta={theGreatBurgerPageMeta} mdxType="LinkWithThumbnail" />
    <h3>{`お得なテイクアウト`}</h3>
    <h4>{`Take Out Lunch Box (900 円)`}</h4>
    <InstaImage postId="B-E7TQBJRId" mdxType="InstaImage" />
    <p>{`好きなハンバーガーと、フライドポテトのセットを箱詰め。
ポテトは無料で L に変更可能で、ドリンクは＋ 100 円で追加できます！`}</p>
    <InstaImage postId="Bea0zGsgpKt" mdxType="InstaImage" />
    <h3>{`営業可能時間`}</h3>
    <p>{`11:30 ～ 23:00`}</p>
    <h3>{`支払い方法`}</h3>
    <p>{`電子マネー：×
クレカ：○
現金：○`}</p>
    <h3>{`アクセス`}</h3>
    <p>{`原宿駅から徒歩 5 分
明治神宮駅から徒歩 5 分`}</p>
    <GoogleMap lat={35.672523} lng={139.7013421} mdxType="GoogleMap" />
    <hr></hr>
    <h3>{`おわりに`}</h3>
    <p>{`原宿・表参道エリアのテイクアウトができる百名店をご紹介させていただきました！コロナ、コロナ以降もテイクアウトをすることが多くなると思いますが、そんな時にぜひ活用していただければと思います！`}</p>

    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;